"use client";

import { METRICS_EVENTS } from "@cede/types";
import { LiFiBridgeWidget, type LiFiBridgeWidgetProps } from "./LiFiBridgeWidget";
import { PortalModal } from "@/components/ui/portal-modal";
import { useTrackEvent } from "@/hooks/data/useMetricsEvents";

export interface BridgeModalProps extends LiFiBridgeWidgetProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

/**
 * Modal wrapper for the LI.FI Bridge Widget
 */
export function BridgeModal({ open, onOpenChange, ...widgetProps }: BridgeModalProps) {
  useTrackEvent({
    event: METRICS_EVENTS.BRIDGE_MODAL_OPENED,
    properties: () => ({
      service: "lifi",
      toChainId: widgetProps.toChainId,
      fromChainId: widgetProps.fromChainId,
    }),
    enabled: open,
  });

  return (
    <PortalModal
      open={open}
      onOpenChange={onOpenChange}
      className="z-modal py-0 gap-0 sm:w-fit"
      showCloseButton={false}
    >
      <PortalModal.Content scrollable className="px-0">
        <LiFiBridgeWidget {...widgetProps} />
      </PortalModal.Content>
    </PortalModal>
  );
}
